export enum UserVisibility {
  Everyone = 'everyone',
  LoggedIn = 'loggedIn',
}
